export default __webpack_public_path__ + "static/media/right.35801ae2.svg";